/** Sequence external account whose transactions are admin-only in CRM card + job costing views. */
export const SHORT_TERM_OPS_ACCOUNT_NAME = 'Short Term Ops';

export function normalizeSequenceAccountName(name: string | null | undefined): string {
  return (name || '').trim();
}

export function normalizeAccountNameForMatch(name: string | null | undefined): string {
  return normalizeSequenceAccountName(name)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export function isShortTermOpsAccount(
  accountName: string | null | undefined,
  accountId?: string | null,
  knownAccountIds?: ReadonlySet<string> | null,
): boolean {
  if (accountId && knownAccountIds?.has(accountId)) return true;
  const normalized = normalizeAccountNameForMatch(accountName);
  if (!normalized) return false;
  if (normalized === 'short term ops' || normalized === 'sto') return true;
  return normalized.includes('short term ops');
}

export function isAdminOnlyExpense(data: {
  adminOnlyExpense?: unknown;
  sequencePodName?: unknown;
  accountName?: unknown;
  source?: unknown;
  id?: unknown;
} | null | undefined): boolean {
  if (!data) return false;
  if (data.adminOnlyExpense === true) return true;
  if (data.source === 'sequence_short_term_ops') return true;
  if (typeof data.id === 'string' && data.id.startsWith('sto-')) return true;
  if (isShortTermOpsAccount(typeof data.sequencePodName === 'string' ? data.sequencePodName : null)) {
    return true;
  }
  return isShortTermOpsAccount(typeof data.accountName === 'string' ? data.accountName : null);
}

/** Hide Short Term Ops / admin-only rows from non-admin viewers. */
export function filterExpensesForViewer<T extends { adminOnlyExpense?: boolean; sequencePodName?: string }>(
  expenses: T[],
  isAdmin: boolean,
): T[] {
  if (isAdmin) return expenses;
  return expenses.filter(e => !isAdminOnlyExpense(e));
}
